import React, {Component} from 'react';
import {Breadcrumb, Button, Icon, Label, List, Popup} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import localDB from "../../data/localDB";
import DynamicTable from "../../components/extras/DynamicTable";
import DeliveryState from "../../components/sale/DeliveryState";
import C from "../../constants";
import SaleStatus from "../../components/sale/SaleStatus";
import ViewImages from "../../components/utils/ViewImages";

class OrdenNumber extends Component{
    render(){
        return <span>
            N° {this.props.billing_number}
        </span>
    }
}


class State extends Component {
    render() {
        return <DeliveryState state={this.props.sale.delivery_state} id={this.props.sale.id} all_options={false}/>
    }
}

class SaleItems extends React.Component {
    render() {
        return <List divided relaxed>
            { this.props.items.length >0 ?
                this.props.items.map(function (item) {
                    return (
                        <List.Item key={item.id}>
                            <List.Icon name={C.REPAIR_DEVICE_TYPES.find((device_type) => device_type.key===item.details.device_type).icon} size='large' verticalAlign='middle' color='orange'/>
                            <List.Content>
                                <List.Header as='h3'>{item.details['model']}</List.Header>
                                <List.Description>{item.observation}</List.Description>
                                <ViewImages id={item.id} url='sale-item-images'/>
                            </List.Content>
                        </List.Item>
                    )
                }):<List.Item>
                    <List.Content>
                        <List.Description>
                            <Label style={{width:'100%'}}>
                                <Icon name='alarm' /> No se han agregado productos para mantenimiento y/o reparación
                            </Label>
                        </List.Description>
                    </List.Content>
                </List.Item>
            }
        </List>
    }
}

class SaleStatusOptions extends React.Component {
    render() {
        return <SaleStatus delivery_state={this.props.delivery_state} id={this.props.id} options={C.REPAIR_SHOP_STATUS} />
    }
}

class Repairs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            table: {
                headers: ['Orden N°', 'Productos', 'Estado'],
                name: 'Mantenimiento y/o Reparación',
                title: 'Mantenimiento y/o Reparación',
                has_actions: false,
                other_actions: false,
                edit: false,
                can_add: false,
                pagination: true,
                delete: false,
                url: 'repairs',
                values: ['billing_number', 'items', 'delivery_state'],
                component_fields:[{
                    billing_number: OrdenNumber,
                    items: SaleItems,
                    delivery_state: SaleStatusOptions
                }],
                id: 'table_repairs',
            },
        };
    }

    buttonObservations = (data) => {
        return <Popup
            trigger={<Button icon='sticky note outline' onClick={()=>this.props.productPricesDialog({id: data.id, name: data.name, is_open:true})}/>}
            content='Observaciones'
            position='top left'
            key={data.id}
        />;
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.product_select && nextProps.product_select.hasOwnProperty('id')){
            localDB.addOrUpdateDB('products', {id:nextProps.product_select.id, name:nextProps.product_select.name});
            this.props.dynamicTableAddOrUpdate(nextProps.product_select);
        }
    }

    render() {

        return (
            <div>
                <Helmet>
                    <title>Mantenimiento y Reparación - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Mantenimiento y Reparación</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
            </div>
        );
    }
}

export default Repairs;



// WEBPACK FOOTER //
// ./src/containers/repairs/Repairs.js